export default "__VITE_ASSET__Cmv7LmTE__"